import { TZDateMini } from '@date-fns/tz';

import { formatDate } from '@dynatrace-sdk/units';
import { getTimezone } from '@dynatrace-sdk/user-preferences';

import { useCalendarContext } from '../hooks/useCalendarContext.js';

/**
 * SelectDateLabel component
 * Renders the formatted label for the select date view.
 * @internal
 */
export const SelectDateLabel = () => {
  const { state } = useCalendarContext();

  return (
    <>
      {formatDate(new TZDateMini(state.activeDate, getTimezone()), {
        year: 'numeric',
        month: 'long',
      })}
    </>
  );
};
SelectDateLabel['displayName'] = 'SelectDateLabel';
